import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'
import { Separator } from '@/components/ui/separator'
import { Badge } from '@/components/ui/badge'
import {
  User,
  Building2,
  Bell,
  Lock,
  Save,
  Mail,
  Phone,
  Shield,
  Crown,
} from 'lucide-react'

export function AffiliateSettings() {
  const [profile, setProfile] = useState({
    name: 'สมชาย พันธมิตร',
    email: 'affiliate@test.com',
    phone: '081-234-5678',
    lineId: '@somchai_aff',
  })

  const [bank, setBank] = useState({
    bankName: 'ธนาคารกสิกรไทย',
    accountNumber: '123-4-56789-0',
    accountName: 'สมชาย พันธมิตร',
  })

  const [notifications, setNotifications] = useState({
    newReferral: true,
    deposit: true,
    commission: true,
    withdrawal: true,
    promotion: false,
  })

  const [security, setSecurity] = useState({
    twoFactor: false,
    loginNotify: true,
  })

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold">ตั้งค่าบัญชี</h1>
          <p className="text-muted-foreground">จัดการข้อมูลและการตั้งค่าของคุณ</p>
        </div>
        <Button className="gap-2">
          <Save className="h-4 w-4" />
          บันทึกทั้งหมด
        </Button>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        {/* Profile */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <User className="h-5 w-5 text-primary" />
              ข้อมูลส่วนตัว
            </CardTitle>
            <CardDescription>แก้ไขข้อมูลโปรไฟล์ของคุณ</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center gap-4 p-4 rounded-lg bg-muted/30">
              <div className="h-16 w-16 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white text-2xl font-bold">
                {profile.name.charAt(0)}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-semibold">{profile.name}</h3>
                  <Badge className="bg-amber-500 text-white border-0 gap-1">
                    <Crown className="h-3 w-3" />
                    Gold
                  </Badge>
                </div>
                <p className="text-sm text-muted-foreground">รหัส: AFF001</p>
                <p className="text-xs text-muted-foreground">คอมมิชชั่น 35%</p>
              </div>
            </div>

            <div className="space-y-2">
              <Label>ชื่อ-นามสกุล</Label>
              <Input 
                value={profile.name} 
                onChange={(e) => setProfile({...profile, name: e.target.value})}
              />
            </div>
            <div className="space-y-2">
              <Label>อีเมล</Label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input 
                  className="pl-10"
                  value={profile.email} 
                  onChange={(e) => setProfile({...profile, email: e.target.value})}
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label>เบอร์โทรศัพท์</Label>
              <div className="relative">
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                <Input 
                  className="pl-10"
                  value={profile.phone} 
                  onChange={(e) => setProfile({...profile, phone: e.target.value})}
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label>LINE ID</Label>
              <Input 
                value={profile.lineId} 
                onChange={(e) => setProfile({...profile, lineId: e.target.value})}
              />
            </div>
          </CardContent>
        </Card>

        {/* Bank Account */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Building2 className="h-5 w-5 text-primary" />
              บัญชีธนาคาร
            </CardTitle>
            <CardDescription>บัญชีสำหรับรับเงินคอมมิชชั่น</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="p-4 rounded-lg bg-gradient-to-br from-emerald-500/10 to-teal-500/10 border border-emerald-500/20">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-emerald-500/20">
                  <Building2 className="h-6 w-6 text-emerald-500" />
                </div>
                <div>
                  <p className="font-semibold">{bank.bankName}</p>
                  <p className="text-sm text-muted-foreground">{bank.accountNumber}</p>
                  <p className="text-xs text-muted-foreground">{bank.accountName}</p>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              <Label>ธนาคาร</Label>
              <Input 
                value={bank.bankName} 
                onChange={(e) => setBank({...bank, bankName: e.target.value})}
              />
            </div>
            <div className="space-y-2">
              <Label>เลขบัญชี</Label>
              <Input 
                value={bank.accountNumber} 
                onChange={(e) => setBank({...bank, accountNumber: e.target.value})}
              />
            </div>
            <div className="space-y-2">
              <Label>ชื่อบัญชี</Label>
              <Input 
                value={bank.accountName} 
                onChange={(e) => setBank({...bank, accountName: e.target.value})}
              />
            </div>

            <p className="text-xs text-muted-foreground">
              * การเปลี่ยนบัญชีธนาคารจะต้องผ่านการตรวจสอบก่อน
            </p>
          </CardContent>
        </Card>

        {/* Notifications */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Bell className="h-5 w-5 text-primary" />
              การแจ้งเตือน
            </CardTitle>
            <CardDescription>ตั้งค่าการแจ้งเตือนที่ต้องการรับ</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>สมาชิกใหม่</Label>
                <p className="text-xs text-muted-foreground">แจ้งเตือนเมื่อมีสมาชิกสมัครผ่านลิงก์ของคุณ</p>
              </div>
              <Switch 
                checked={notifications.newReferral}
                onCheckedChange={(checked) => setNotifications({...notifications, newReferral: checked})}
              />
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>ยอดฝาก</Label>
                <p className="text-xs text-muted-foreground">แจ้งเตือนเมื่อสมาชิกที่แนะนำฝากเงิน</p>
              </div>
              <Switch 
                checked={notifications.deposit}
                onCheckedChange={(checked) => setNotifications({...notifications, deposit: checked})}
              />
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>คอมมิชชั่น</Label>
                <p className="text-xs text-muted-foreground">แจ้งเตือนเมื่อได้รับคอมมิชชั่น</p>
              </div>
              <Switch 
                checked={notifications.commission}
                onCheckedChange={(checked) => setNotifications({...notifications, commission: checked})}
              />
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>การถอนเงิน</Label>
                <p className="text-xs text-muted-foreground">แจ้งเตือนสถานะการถอนเงิน</p>
              </div>
              <Switch 
                checked={notifications.withdrawal}
                onCheckedChange={(checked) => setNotifications({...notifications, withdrawal: checked})}
              />
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>โปรโมชั่น</Label>
                <p className="text-xs text-muted-foreground">รับข่าวสารโปรโมชั่นใหม่ๆ</p>
              </div>
              <Switch 
                checked={notifications.promotion}
                onCheckedChange={(checked) => setNotifications({...notifications, promotion: checked})}
              />
            </div>
          </CardContent>
        </Card>

        {/* Security */}
        <Card>
          <CardHeader>
            <CardTitle className="text-lg flex items-center gap-2">
              <Shield className="h-5 w-5 text-primary" />
              ความปลอดภัย
            </CardTitle>
            <CardDescription>ตั้งค่าความปลอดภัยของบัญชี</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>ยืนยันตัวตน 2 ขั้นตอน (2FA)</Label>
                <p className="text-xs text-muted-foreground">เพิ่มความปลอดภัยด้วย Google Authenticator</p>
              </div>
              <Switch 
                checked={security.twoFactor}
                onCheckedChange={(checked) => setSecurity({...security, twoFactor: checked})}
              />
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg bg-muted/30">
              <div>
                <Label>แจ้งเตือนเข้าสู่ระบบ</Label>
                <p className="text-xs text-muted-foreground">แจ้งเตือนทางอีเมลเมื่อมีการเข้าสู่ระบบ</p>
              </div>
              <Switch 
                checked={security.loginNotify}
                onCheckedChange={(checked) => setSecurity({...security, loginNotify: checked})}
              />
            </div>

            <Separator />

            <div className="space-y-2">
              <Label>เปลี่ยนรหัสผ่าน</Label>
              <div className="space-y-2">
                <Input type="password" placeholder="รหัสผ่านปัจจุบัน" />
                <Input type="password" placeholder="รหัสผ่านใหม่" />
                <Input type="password" placeholder="ยืนยันรหัสผ่านใหม่" />
              </div>
              <Button variant="outline" className="w-full gap-2">
                <Lock className="h-4 w-4" />
                เปลี่ยนรหัสผ่าน
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}










